export type OfferBarcodeType = 'C128' | 'PDF417' | 'QRCODE' | 'NONE';
export type OfferDenominationType = 'FIXED' | 'VARIABLE' | 'VARIABLENOCENTS';
export type OfferStatus = 'ON' | 'OFF';
export enum PreferredOfferType {
  REGULAR = 'REGULAR',
  CLO = 'CLO',
}
